import gqlTagGira from 'graphql-tag';

export const SCHEDULE_TIMELINE_ITEM_MUTATION = gqlTagGira`
    mutation ScheduleTimelineItem($input: ScheduleTimelineItemInput!) {
		jira{
			scheduleTimelineItem(input: $input) {
				success
				errors {
					message
					extensions {
						statusCode
						errorType
					}
				}
			}
		}
    }
`;
